import { Car, Star, Accessibility, SquareParking, Wifi, Baby, PawPrint, Gift } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const FEATURES = [
    {
        id: "trato-detalle",
        icon: Car,
        title: "Trato al Detalle",
        text: "Tratamos tu coche como si fuera el nuestro, cuidando cada pequeño detalle",
    },
    {
        id: "estrellas-google",
        icon: Star,
        title: "4,7 Estrellas en Google",
        text: "13 reseñas de clientes satisfechos nos avalan",
    },
    {
        id: "accesible",
        icon: Accessibility,
        title: "Accesible",
        text: "Fácil acceso para personas con movilidad reducida",
    },
    {
        id: "parking",
        icon: SquareParking,
        title: "Parking Propio",
        text: "Plaza de aparcamiento disponible para clientes",
    },
];

const AMENITIES = [
    { id: "wifi", icon: Wifi, label: "Wi-Fi" },
    { id: "ninos", icon: Baby, label: "Apto para niños" },
    { id: "mascotas", icon: PawPrint, label: "Se admiten mascotas" },
    { id: "fidelidad", icon: Gift, label: "Programa de fidelidad" },
];

export const WhyUs = () => (
    <section data-testid="why-us-section" className="bg-ink py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <p className="gold-text text-xs font-bold uppercase tracking-[0.3em]">
                    02 · La diferencia está en los detalles
                </p>
                <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-[#F3F4F6] sm:text-5xl">
                    ¿Por qué elegirnos?
                </h2>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
                {FEATURES.map((feature, index) => (
                    <Reveal key={feature.id} delay={index * 0.08} className="h-full">
                        <article
                            data-testid={`feature-card-${feature.id}`}
                            className="h-full rounded-md border border-white/10 bg-white/[0.04] p-6 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-white/25 hover:shadow-xl hover:shadow-black/40"
                        >
                            <div className="mb-5 inline-flex items-center justify-center rounded-sm bg-gold p-3.5">
                                <feature.icon className="h-7 w-7 text-ink" />
                            </div>
                            <h3 className="font-display text-lg font-bold text-[#F3F4F6]">
                                {feature.title}
                            </h3>
                            <p className="mt-2.5 text-sm leading-relaxed text-gray-400">
                                {feature.text}
                            </p>
                        </article>
                    </Reveal>
                ))}
            </div>

            <Reveal className="mt-12">
                <div
                    data-testid="amenities-row"
                    className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4 border-t border-white/10 pt-10"
                >
                    {AMENITIES.map((amenity) => (
                        <span
                            key={amenity.id}
                            data-testid={`amenity-${amenity.id}`}
                            className="inline-flex items-center gap-2 text-sm font-semibold text-gray-300"
                        >
                            <amenity.icon className="h-4 w-4 text-gold" />
                            {amenity.label}
                        </span>
                    ))}
                </div>
            </Reveal>
        </div>
    </section>
);
